// Types
import type { RouteLocationNormalized, RouteRecordName } from 'vue-router';
import type { TAuthToken, TBaseAuthStore } from '~/misc/auth/types';

export const useAuthMiddleware = <User>(
  store: TBaseAuthStore<User>,
  terminateFn: () => void,
  authPaths: string[],
  homeRoute: string,
  loginRoute: string,
  setRedirectRoute: (route: string) => void
) => {
  const handle = (_to: RouteLocationNormalized, _from: RouteLocationNormalized) => {
    const toPath: RouteRecordName | null | undefined = _to.name;

    const authToken: TAuthToken | null = store.token;
    const isAuthTokenValid: boolean = authToken ? authToken.expiresAt > Date.now() : false;

    const isAuthPath = () => {
      if (!toPath || typeof toPath === 'symbol') return;

      return authPaths.includes(toPath);
    };

    if (isAuthTokenValid && isAuthPath()) {
      return navigateTo(homeRoute);
    }

    if (!(isAuthTokenValid || isAuthPath())) {
      setRedirectRoute(_to.fullPath);
      terminateFn();

      return navigateTo(loginRoute);
    }
  };

  return { handle };
};
